/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  SocialHistoryResponseDto,
  SocialHistoryUpsertRequestDto,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SocialHistoryResponseDtoFromJSON,
    SocialHistoryResponseDtoToJSON,
    SocialHistoryUpsertRequestDtoFromJSON,
    SocialHistoryUpsertRequestDtoToJSON,
} from '../models/index';

export interface GetSocialHistoryByPatientIdRequest {
    patientId: string;
}

export interface UpsertSocialHistoryRequest {
    socialHistoryUpsertRequestDto: SocialHistoryUpsertRequestDto;
}

export interface UpsertSocialHistoryByPatientIdRequest {
    patientId: string;
    socialHistoryUpsertRequestDto: SocialHistoryUpsertRequestDto;
}

/**
 * 
 */
export class PatientSocialHistoryApi extends runtime.BaseAPI {

    /**
     * Get patient\'s social history
     */
    async getSocialHistoryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialHistoryResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/social-history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s social history
     */
    async getSocialHistory(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialHistoryResponseDto> {
        const response = await this.getSocialHistoryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s social history by patient ID
     */
    async getSocialHistoryByPatientIdRaw(requestParameters: GetSocialHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getSocialHistoryByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/social-history/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get patient\'s social history by patient ID
     */
    async getSocialHistoryByPatientId(requestParameters: GetSocialHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialHistoryResponseDto> {
        const response = await this.getSocialHistoryByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create patient\'s social history
     */
    async upsertSocialHistoryRaw(requestParameters: UpsertSocialHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['socialHistoryUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'socialHistoryUpsertRequestDto',
                'Required parameter "socialHistoryUpsertRequestDto" was null or undefined when calling upsertSocialHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/social-history`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SocialHistoryUpsertRequestDtoToJSON(requestParameters['socialHistoryUpsertRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create patient\'s social history
     */
    async upsertSocialHistory(requestParameters: UpsertSocialHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.upsertSocialHistoryRaw(requestParameters, initOverrides);
    }

    /**
     * Create patient\'s social history by patient ID
     */
    async upsertSocialHistoryByPatientIdRaw(requestParameters: UpsertSocialHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SocialHistoryResponseDto>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling upsertSocialHistoryByPatientId().'
            );
        }

        if (requestParameters['socialHistoryUpsertRequestDto'] == null) {
            throw new runtime.RequiredError(
                'socialHistoryUpsertRequestDto',
                'Required parameter "socialHistoryUpsertRequestDto" was null or undefined when calling upsertSocialHistoryByPatientId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/patients/social-history/{patientId}`.replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SocialHistoryUpsertRequestDtoToJSON(requestParameters['socialHistoryUpsertRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SocialHistoryResponseDtoFromJSON(jsonValue));
    }

    /**
     * Create patient\'s social history by patient ID
     */
    async upsertSocialHistoryByPatientId(requestParameters: UpsertSocialHistoryByPatientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SocialHistoryResponseDto> {
        const response = await this.upsertSocialHistoryByPatientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
